export default __webpack_public_path__ + "static/media/512.a7b63bc9.png";